import { render } from "./MyTaskView.vue?vue&type=template&id=e4053dc8&scoped=true"
import script from "./MyTaskView.vue?vue&type=script&lang=js"
export * from "./MyTaskView.vue?vue&type=script&lang=js"

import "./MyTaskView.vue?vue&type=style&index=0&id=e4053dc8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4053dc8"]])

export default __exports__